import { Injectable, OnDestroy } from "@angular/core";
import { Subject, BehaviorSubject, fromEvent } from "rxjs";
import { takeUntil, debounceTime } from "rxjs/operators";
import { Router } from "@angular/router";
import { DataService } from "./data.svc";

// Menu
export interface Menu {
  headTitle1?: string;
  headTitle2?: string;
  path?: string;
  title?: string;
  icon?: string;
  type?: string;
  badgeType?: string;
  badgeValue?: string;
  active?: boolean;
  bookmark?: boolean;
  children?: Menu[];
  status?: boolean;
  custom?: boolean;
}

@Injectable({
  providedIn: "root",
})
export class NavService implements OnDestroy {
  private unsubscriber: Subject<any> = new Subject();
  public screenWidth: BehaviorSubject<number> = new BehaviorSubject(window.innerWidth);

  // Search Box
  public search: boolean = false;

  // Language
  public language: boolean = false;

  // Mega Menu
  public megaMenu: boolean = false;
  public levelMenu: boolean = false;
  public megaMenuColapse: boolean = window.innerWidth < 1199 ? true : false;

  // Collapse Sidebar
  public collapseSidebar: boolean = window.innerWidth < 991 ? true : false;

  // For Horizontal Layout Mobile
  public horizontal: boolean = window.innerWidth < 991 ? false : true;

  // Full screen
  public fullScreen: boolean = false;

  constructor(private router: Router, private svcData: DataService) {
    this.setScreenWidth(window.innerWidth);
    fromEvent(window, "resize")
      .pipe(debounceTime(1000), takeUntil(this.unsubscriber))
      .subscribe((evt: any) => {
        this.setScreenWidth(evt.target.innerWidth);
        if (evt.target.innerWidth < 991) {
          this.collapseSidebar = true;
          this.megaMenu = false;
          this.levelMenu = false;
        }
        if (evt.target.innerWidth < 1199) {
          this.megaMenuColapse = true;
        }
      });
    if (window.innerWidth < 991) {
      // Detect Route change sidebar close
      this.router.events.subscribe((event) => {
        this.collapseSidebar = true;
        this.megaMenu = false;
        this.levelMenu = false;
      });
    }
  }

  ngOnDestroy() {
    // this.unsubscriber.next();
    this.unsubscriber.complete();
  }

  private setScreenWidth(width: number): void {
    this.screenWidth.next(width);
  }

  MENUITEMS: Menu[] = [
    {
      headTitle1: "General",
    },
    {
      title: "Dashboard",
      icon: "home",
      type: "sub",
      badgeType: "light-primary",
      active: true,
      status: true,
      path: "/dashboard/default",
    },
    {
      title: "Users",
      icon: "user",
      type: "sub",
      active: false,
      status: false,
      path: "/dashboard/user",
    },
    {
      title: "Analytics",
      icon: "charts",
      type: "sub",
      active: false,      
      status: false,
      path: "/dashboard/daily",
    },

    {
      title: "Reports",
      icon: "layout",
      type: "sub",
      active: false,
      status: true,
      path: "/dashboard/report",
    },
    {
      title: "Settings",
      icon: "editors",
      type: "sub",
      active: false,
      status: false,
      path: "/dashboard/setting",
    },
    {
      title: "Data Viewer",
      icon: "sample-page",
      type: "sub",
      active: false,
      status: false,
      path: "/dashboard/data-viewer",
    },
    {
      title: "Monthly Overview",
      icon: "calendar",
      type: "sub",
      active: false,
      status: false,
      path: "/dashboard/calendar",
    },
    {
      title: "Logout",
      icon: "logout",
      type: "sub",
      active: false,
      status: true,
      path: "/logout"
    },
    {
      title: "",
      icon: "",
      type: "",
      active: false,
    },
  ];

  // Array
  items = new BehaviorSubject<Menu[]>(this.MENUITEMS);
}
